@import '~style-sheet-helpers/core.less';
@import (reference) '../../../../../../../constants/spacing.module.less';

.alternate-location-wrapper {
  padding: 20px;
  width: 600px;
}

.modal-buttons {
  display: flex;
  justify-content: flex-end;
  height: 100%;
  align-items: center;
  gap: @space-16;
  padding: 8px;
}

.field-section {
  padding-bottom: @space-12;
  border-bottom: 1px solid var(--gray-DFE4E8);
}

.field-group-wrapper {
  padding-top: @space-16;
}
